// extracted by mini-css-extract-plugin
export default {"img":"Banner_img__YQ8gD","container":"Banner_container__i+8we","button":"Banner_button__PrccL","buttons":"Banner_buttons__w36gW"};